import React from 'react';

/**
 * Full-screen overlay shown when user is dragging files over the dropzone.
 */
const DropzoneOverlay = React.memo(function DropzoneOverlay() {
  return (
    <div
      className="dropzone-overlay"
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0, 0, 0, 0.25)',
        border: '2px dashed var(--primary-color, #0d6efd)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 600,
        fontSize: '1.25rem',
        zIndex: 1000,
        pointerEvents: 'none',
        borderRadius: '6px',
        backdropFilter: 'blur(1px)',
      }}
    >
      Drop files to upload
    </div>
  );
});

export default DropzoneOverlay;
